module.exports = __webpack_public_path__ + "img/cola.09bce633.jpg";